import React from 'react';
import { Link } from "react-router-dom";
import { FormattedMessage } from 'react-intl';
import { Table, Typography } from 'antd';
import { PRINTERS_PATH } from '../utils/constants';
import SearchTable from './SearchTable'
import { drawSupply, compareStrings, TrimNan,  } from '../utils/utils';

const SuppliesLevelTable = (props) => {
    const columns = [   
        {          
            dataIndex: 'description',
            
            width: 250,
        },    
        {
            dataIndex: 'level',
            
            render: (_, record) => drawSupply(record)                    
        },
    ];   
        
    return (
         <Table bordered showSizeChanger={false} pagination={false} rowKey={record => record.id} columns={columns} dataSource={props.items}/>
    );
};

const layout = {
    bordered : false,
    showSizeChanger : true, 
    pagination : {pageSize: 100, showSizeChanger: false},
    size: "small",
    rowKey : record => record.id,
};

const HardwareTableEx = (props) => {

    const columns = [   
        {
            title: <FormattedMessage id="SuppliesHistoryTable.device"/>,
            dataIndex: 'prnName',
            
            width: 300,
            search: true,
            sorter: {
                    compare: (a, b) => compareStrings(a.prnName, b.prnName),
            },
            render: (_, record) => {
                if (record.enabled === 1)
                {
                    const url = PRINTERS_PATH + "/" + record.id;
                    return(
                    <div>
                        <Link to={url}>{record.prnName}</Link>
                    </div>
                    );        
                }
                else
                {
                    return(<Typography.Text disabled>{record.prnName}</Typography.Text>);
                }
            }
        },    
        {
            title: <FormattedMessage id="HardwareTable.manufacturer"/>,
            dataIndex: 'manufacturer',
            
            width: 200,
            search: true,
            sorter: {
                compare: (a, b) => compareStrings(a.manufacturer, b.manufacturer),
            },
        },
        {
            title: <FormattedMessage id="SuppliesHistoryTable.model"/>,
            dataIndex: 'model',
            
            width: 200,
            search: true,
            sorter: {
                compare: (a, b) => compareStrings(a.model, b.model),
            },
        },
        {
            title: <FormattedMessage id="HardwareTable.serial"/>,
            dataIndex: 'serialNumber',
            
            width: 200,
            search: true,
            sorter: {
                compare: (a, b) => compareStrings(a.serialNumber, b.serialNumber),
            },
        },
        {
            title: <FormattedMessage id="DeviceMetersTable.ip"/>,
            dataIndex: 'ip',
            
            search: true,
            sorter: {
                compare: (a, b) => compareStrings(a.ip, b.ip)
            },
            render: (_, record) => {
                    return(
                    <div>
                        <a href={'http://' + record.ip} target='_blank' rel="noopener noreferrer">{record.ip}</a>
                    </div>
                    );        
            },
        },
        {
            title: <FormattedMessage id="SuppliesChangesTable.current_level"/>,
            dataIndex: 'supplies',
            
            align: 'center',
            render: (_, record) => {
                return(
                <div>
                {   record.supplies instanceof Array &&
                    record.supplies.length > 0 &&
                    <SuppliesLevelTable items = {record.supplies}/>
                }
                </div>
                );        
        },
        },
        {
            title: <FormattedMessage id="DeviceMetersTable.pages"/>,
            dataIndex: 'pagesCount',
            
            align: 'right',
            search: true,             
            sorter: {
                compare: (a, b) =>  TrimNan(a.pagesCount) -  TrimNan(b.pagesCount)
            },
        },
    ];   
        
    return (
        <div className = "report-table">
            <SearchTable
                layout = {layout}
                type = "checkbox"
                columns={columns} 
                dataSource={props.data}
                onSelectChange={props.onSelectChange} 
            />
        </div>
    );
}

export default HardwareTableEx;
